export const DOMAIN = "activation.widget.topics.pieChart.tooltip.domain";
export const SHARE = "activation.widget.topics.pieChart.tooltip.share";
